export default __webpack_public_path__ + "assets/apple_pay-f78bf969cc6403c950316be8f43b4249.png";